import React from "react";
import { themeModes } from "../../configs/themeConfig";
import { setThemeMode } from "../../redux/features/themeSlice";

import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import WbSunnyOutlinedIcon from "@mui/icons-material/WbSunnyOutlined";
import { useDispatch, useSelector } from "react-redux";
import { Box, IconButton } from "@mui/material";

const ChangeTheme = () => {
  const { themeMode } = useSelector((state) => state.themeMode);
  const dispatch = useDispatch();

  const onSwithTheme = () => {
    const theme =
      themeMode === themeModes.dark ? themeModes.light : themeModes.dark;
    dispatch(setThemeMode(theme));
  };

  return (
    <Box>
      <IconButton
        sx={{ background: "orange", borderRadius: "0px" }}
        onClick={onSwithTheme}
      >
        {themeMode === themeModes.dark && <DarkModeOutlinedIcon />}
        {themeMode === themeModes.light && <WbSunnyOutlinedIcon />}
      </IconButton>
    </Box>
  );
};

export default ChangeTheme;
